import { emptyApi } from './emptyApi'
import { MemberCenter } from '../../types'
import { camelCaseResponse, providesList } from '../../shared/Functions'

export const memberCenterService = emptyApi.injectEndpoints({
  endpoints: (builder) => ({
    getMemberCenters: builder.query<MemberCenter[], void>({
      query: () => '/member_centers',
      transformResponse: (response: unknown) => {
        return camelCaseResponse(
          response as Record<string, unknown>
        ) as MemberCenter[]
      },
      providesTags: (results) => providesList(results, 'MemberCenter')
    })
  })
})

export const { useGetMemberCentersQuery } = memberCenterService
